import * as BABYLON from "babylonjs"
import { Player } from "../classes/player"
import { DialPicker } from "../components/3DUIElements/DialPicker"
import { Global } from "../classes/global"

export class HandMenu {
	static enable(
		scene: BABYLON.Scene,
		xr: BABYLON.WebXRDefaultExperience
	): void {
		var mesh = scene.getMeshByName("UI_parent_settings")
		// Try to enable hand tracking
		const featureManager = xr.baseExperience.featuresManager

		const xrHandFeature = featureManager.enableFeature(
			BABYLON.WebXRFeatureName.HAND_TRACKING,
			"latest",
			{
				xrInput: xr.input,
			}
		) as BABYLON.WebXRHandTracking

		xrHandFeature.onHandAddedObservable.add((hand) => {
			if (hand.xrController.inputSource.handedness === "left") {
				mesh!.parent = hand.getJointMesh(BABYLON.WebXRHandJoint.WRIST)
				mesh!.scaling.x = 16
				mesh!.scaling.y = 16
				mesh!.rotation.x = Math.PI / 2
			} else {
				Global.xr_right = hand.getJointMesh(
					BABYLON.WebXRHandJoint.INDEX_FINGER_TIP
				)
			}
		})
		// Fallback to controller if no hand is detected
		xr.input.onControllerAddedObservable.add((controller) => {
			controller.onMotionControllerInitObservable.add((motionController) => {
				motionController.onModelLoadedObservable.add(() => {
					if (controller.inputSource.handedness === "left") {
						mesh!.parent = controller.grip || controller.pointer
						mesh!.isVisible = true
						mesh!.position = new BABYLON.Vector3(0, 0.05, 0)
						mesh!.rotation.x = Math.PI / 2
						mesh!.scaling.x = 0.3
						mesh!.scaling.y = 0.3
					} else {
						Global.xr_right = controller.grip || controller.pointer
					}
					//mesh!.scaling.divideInPlace(mesh!.parent!.scaling)
				})
			})
		})
	}
}
